import moment from 'moment';
import React, { useEffect, useState } from 'react';
import CanvasJSReact from '../../../assets/js/canvasjs.react';
import { fetchChartData } from '../../../services/dashboard';
import * as _ from 'lodash';
import WeekModal from '../common/WeekModal';
import { loadingEnd, loadingStart } from '../../../store/loadingIndicator/loadingIndicatorSlice';
import { useAppDispatch } from '../../../store/hook';
import { DateModal } from '../common/DateModal';
import { getOverdueData } from '../../../services/mainDashboard';
import configs from '../../../configs/apiConfigs';
var CanvasJS:any = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

export const Overdue = ({ clinicId }: any) => {
    const [dataPoints, setDataPoints] = useState([{ name: 'May 1', y: 5, color: '#FFCD46' }, { name: 'May 1', y: 20, color: '#4c8BF5' }, { name: 'May 1', y: 20, color: '#ed7d31' }, { name: 'May 1', y: 20, color: '#7AD7F0' }]);
    const [overdueData, setOverdueData]: any = useState('');
    const [isShowNoData, setIsShowNoData] = useState(false);
    const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
    const [startDate, setStartDate] = useState(moment().subtract(6, 'days').format('YYYY-MM-DD'));
    const [isDateChange, setIsDateChange] = useState(false);
    const [colors, setColors] = useState(['#FFCD46', '#4c8BF5', '#ed7d31', '#7AD7F0']);
    const [totalOverdueCount, setTotalOverdueCount] = useState(0);
    const [months, setMonths] = useState(['0-6 Mo.', '7-12 Mo.', '3-17 Mo.', '18-24 Mo.']);
    const dispatch = useAppDispatch();
    const [isLoading, setIsLoading] = useState(false);
let controller: any;
    useEffect(() => {
        if (clinicId) {
            controller = new AbortController();
            setTimeout(() => {
                fetchData();
            }, 1000);
        }
        return () => {
            if (controller) {
                controller.abort()
            }
        }
    }, [startDate, endDate, clinicId]);
    
    const fetchData = () => {
        setIsLoading(true);
        let overdueDate: any = moment().subtract(1, 'day').format('YYYY/MM/DD');
        getOverdueData(overdueDate,controller)
            .then((success) => {
                setIsLoading(false);
                let data: any = [];
                if (success && success.overdue) {
                    let findClinic: any = success.overdue.find((item: any) => { return item.id === clinicId });
                    if (findClinic) {
                        data.push({name: '0-6 Mo.', y: Number(findClinic.zeroToSix.count), color: '#FFCD46',month: '0-6 Mo.'});
                        data.push({name: '7-12 Mo.', y: Number(findClinic.sevenToTwelve.count), color: '#4c8BF5',month: '7-12 Mo.'});
                        data.push({name: '13-17 Mo.', y: Number(findClinic.thirteenToEighteen.count), color: '#ed7d31',month: '13-17 Mo.'});
                        data.push({ name: '18-24 Mo.', y: Number(findClinic.nineteenToTwentyfour.count), color: '#7AD7F0', month: '18-24 Mo.' });
                        setTotalOverdueCount(
                            Number(findClinic.zeroToSix.count) + Number(findClinic.sevenToTwelve.count) +
                            Number(findClinic.thirteenToEighteen.count) + Number(findClinic.nineteenToTwentyfour.count)
                        )
                        setOverdueData(data);
                    }
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log('Error while fetching data overdue', error);
            })

        // fetchChartData('unscheduled',clinicId, startDate, endDate)
        //     .then((success) => {
        //         if (success && Number(success.unscheduledCount) > 0) {
        //             setUnScheduledData([{name: moment(startDate,'YYYY-MM-DD').format('MMM DD'), y: Number(success.unscheduledCount), color: '#FFCD46'}])
        //         } else {
        //             setUnScheduledData([]);
        //         }
        //     })
        //     .catch((error) => {
        //         console.log('error while fetching data - schedule', error);
        //     })
    }

    useEffect(() => {
        if (overdueData && overdueData.length > 0) {
            let options = {
                animationEnabled: true,
                theme: "light2",
                // title: {
                //     text: 'UnScheduled',
                //     fontSize: 10,
                // },
                legend: {
                    fontFamily: "calibri",
                    fontSize: 14,
                    fontWeight: "normal",
                    fontColor: "#9d9d9d",
                    dockInsidePlotArea: false,
                    verticalAlign: "center",
                    horizontalAlign: "right",
                    itemWidth: 140,
                    itemTextFormatter: function (e: any) {
                        return e.dataPoint.month + " -  " + Math.round(e.dataPoint.y);
                    }
                },
                data: [{
                    cursor: "pointer",
                    explodeOnClick: false,
                    innerRadius: "69%",
                    // legendMarkerType: "square",
                    name: 'Overdue',
                    radius: "100%",
                    showInLegend: true,
                    startAngle: 90,
                    type: "doughnut",
                    // indexLabel: "{y}",
                    indexLabelFormatter: function (e: any) {
                        if (e.dataPoint.y) {
                            return e.dataPoint.y;
                        }
                    },
                    indexLabelTextAlign: "left",
                    indexLabelPlacement: "inside",
                    indexLabelFontColor: "black",
                    dataPoints: overdueData
                }]
            }
            var charts = new CanvasJS.Chart("overdue", options);
            charts.render();
        }
    }, [overdueData]);

    const handleDateChange = (sDate: any, eDate: any) => {
        setStartDate(sDate);
        setEndDate(eDate);
        setIsDateChange(false)
    }
    return (
        <div className="col-4 mb-4">
            
            <div className="card">
                        <>
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h6 className="m-0">Overdue</h6>
                                <div>
                                    <button type="button" onClick={() => { setIsDateChange(true) }} className="btn p-1"><i className="bi bi-calendar-week"></i></button>
                                    <a href={configs.API_URL+'download/overdue/'+clinicId+'/?date='+moment().format('YYYY-MM-DD')} target="_blank" type="button" className="btn p-1"><i className="bi bi-download"></i></a>
                                    {/* <button type="button" className="btn p-1"><i className="bi bi-info-circle"></i></button> */}
                                </div>
                            </div>
                            <div className="card-body" style={{height:'290px'}}>
                            {
                                isLoading ?
                                    <div className="mt-5 loder_in rounded text-center">
                                        <div className="spinner-border align-items-center" role="status">
                                        </div>
                                        <div className="mt-2">Loading...</div>
                                    </div>
                                    :
                                    <>
                                        <div className="graph-area">
                        
                                            {/* <img src={require("../../../assets/images/chart/Unscheduled.png")} alt='image not found' /> */}
                                            {
                                                overdueData.length === 0 &&
                                                <div>No Record found.</div>
                                            }
                                            <div className='w-100 h-100' id="overdue"></div>
                                        </div>
                                        <div className="bottom-data d-flex gap-3">
                                            <div className="btms-data">
                                                <span>Total Overdue</span>
                                                <div>{totalOverdueCount}</div>
                                            </div>
                                        </div>
                                    </>
                            }
                            </div>
                        </>
            </div>
            {
                (isDateChange) &&
                <DateModal
                    show={isDateChange}
                    maxDate={moment().subtract(1,'day').format('YYYY/MM/DD')}
                    handleClose={() => { setIsDateChange(false) }}
                    handleDateChange={(sDate: any, eDate: any) => { handleDateChange(sDate, eDate) }}
                />
            }
        </div>
    )
}